// Constants for Mercos site numbers
// Centralized place to manage all the client numbers and revenue figures

export const SITE_CONSTANTS = {
  // Client numbers (updated to 9 mil)
  CLIENTS_COUNT: '9 mil',
  CLIENTS_COUNT_WITH_PLUS: '+9 mil',
  CLIENTS_COUNT_DETAILED: '9.000',
  CLIENTS_COUNT_WITH_COMMA: '9 mil',
  
  // Revenue (updated to 80 bi)
  ANNUAL_REVENUE: 'R$ 80 BI',
  ANNUAL_REVENUE_LOWERCASE: 'R$ 80 bi',
  
  // Other numbers that might be used
  USERS_COUNT: '+52 mil',
  ERPS_INTEGRATED: '+250',
  ANNUAL_ORDERS: '+ 14 MI'
}

// Helper functions to get formatted numbers
export const getClientsCount = (format = 'default') => {
  switch (format) {
    case 'plus':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_PLUS
    case 'detailed':
      return SITE_CONSTANTS.CLIENTS_COUNT_DETAILED
    case 'comma':
      return SITE_CONSTANTS.CLIENTS_COUNT_WITH_COMMA
    default:
      return SITE_CONSTANTS.CLIENTS_COUNT
  }
}

export const getRevenue = (lowercase = false) => {
  return lowercase ? SITE_CONSTANTS.ANNUAL_REVENUE_LOWERCASE : SITE_CONSTANTS.ANNUAL_REVENUE
}


// WEBPACK FOOTER //
// /usr/src/site-blog/src/utils/constants.js